import * as googleAnalytics from "./googleAnalytics";
import * as queryStringHelpers from "./queryStringHelpers";
import {useEffect} from "react";

export default function usePageView(title: string) {
    useEffect(() => {
        const qs = queryStringHelpers.objectify(window.location.search);
        if (qs.m !== "300") {
            googleAnalytics.pageView(window.location.href, window.location.pathname, title);
        }
    }, [title]);
}
